module.exports = ".text-wrap {\n  text-wrap: pretty !important; }\n\n.text-end {\n  text-align: end; }\n\n.child-progress {\n  width: 90% !important; }\n\n.label-text {\n  padding-left: 1px !important; }\n\n.stage-children-wbs {\n  margin-left: 15px; }\n\n.stage-children-wbs .progress {\n    width: 21vw !important; }\n\nduration-inprogress {\n  background-color: #17a2b8 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/project-execution-stage/project-execution-stage.component.scss
// module id = ./src/app/components/project-execution-stage/project-execution-stage.component.scss
// module chunks = main